<template lang="pug">
  .edit-team-task-form
    div.columns(v-if="value.type!=='backlog'")
      div.column(v-if="value.isInTasks && !(value.isHelpdeskTask && value.isHelpdeskDone)")
        b-field(label="Статус*", :type="errors && errors.status ? 'is-danger' : ''", :message="errors.status")
          b-select(v-model="value.team_status")
            option(v-for="(status, key) in value.teamStatuses" :value="key" :key="key")
              | {{ status.name }}
      div.column(v-else)
        b-field(label="Статус")
          task-status(v-if="value.status", :status="value.status", tooltip-position="is-right", icon-only)
      div.column
        b-field(label="Исполнитель*", :type="errors && errors.executor_id ? 'is-danger' : ''", :message="errors.executor_id")
          b-select(v-model="value.executor_id")
            option(v-for="(name, key) in value.executors" :value="key" :key="key")
              | {{ name }}
      div.column
        b-field(:label="value.isHelpdeskTask ? 'Создан:' : 'Создана'")
          p {{ value.createdAt | dateFormat }}
      div.column
        b-field(v-if="value.isTeamTask", label="Автор:")
          p {{ value.author.first_name }}
        b-field(v-else, label="Платформа:")
          p {{ value.platformName }}
    p(v-if="value.type!=='backlog'") {{ value.statusDates }}

    b-field(label="Дедлайн", :type="errors && errors.format_deadline_at ? 'is-danger' : ''", :message="errors.format_deadline_at")
      b-input(v-model="value.format_deadline_at", type="date")

    b-field(:label="(value.isHelpdeskTask ? 'Заголовок тикета' : 'Заголовок задачи*')", :type="errors && errors.title ? 'is-danger' : ''", :message="errors.title", class="mb-0")
      div.mb-2(v-if="value.isHelpdeskTask") {{ value.title }}
      b-input(v-else, v-model="value.title", maxlength="250", type="textarea", rows="2")

    b-field(:label="value.isHelpdeskTask ? 'Описание тикета' : 'Описание задачи'", :type="errors && errors.body ? 'is-danger' : ''", :message="errors.body")
      div.mb-2(v-if="value.isHelpdeskTask") {{ value.body }}
      b-input(v-else, v-model="value.body", type="textarea", rows="8")

    ui-simple-files.mt-5(v-if="value.files && !value.isHelpdeskTask", :files="value.files")

    template(v-if="value.isHelpdeskTask")
      router-link(:to="{ name: 'task', params: { id: value.id }}", target="_blank")
        | Перейти в тикет
</template>

<script>
import BSelect from 'buefy/src/components/select/Select';

export default {
  name: 'edit-team-task-form',
  components: { BSelect },
  props: {
    value: Object,
    errors: Object,
  },
};
</script>

<style scoped></style>
